<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <breadcrumb
      id="breadcrumb-container"
      class="breadcrumb-container"
      :class="{'disabled-click':canClick}"
    />
    <div id="loginUser" class="right-menu">
      <!-- <div style="float:left;margin-right:10px;margin-top:-2px">
        <el-button size="mini" type="primary" round icon="el-icon-s-platform">大屏显示</el-button>
      </div>-->
      <template>
        <div class="user-info">
          <span style="margin-right:10px;">您好，{{name}}</span>
          <span class="aBn" @click="toPassword">
            修改密码
          </span>
          <span style="color:#409eff;"> | </span>
          <span class="aBn" @click="logout">
            退出登录
          </span>
        </div>
        <!-- <search id="header-search" class="right-menu-item" /> -->

        <!-- <error-log class="errLog-container right-menu-item hover-effect" /> -->

        <!-- <screenfull id="screenfull" class="right-menu-item hover-effect" /> -->

        <!-- <el-tooltip content="Global Size" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip>-->
      </template>
      <!-- <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <img src="./images/user.png" class="user-avatar" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/password">
            <el-dropdown-item>修改密码</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/breadcrumb";
import Hamburger from "@/components/common/hamburger";
// import ErrorLog from '@/components/ErrorLog'
// import Screenfull from '@/components/Screenfull'
// import SizeSelect from '@/components/SizeSelect'
// import Search from '@/components/HeaderSearch'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    // ErrorLog,
    // Screenfull,
    // SizeSelect,
    // Search
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    name() {
      return this.$store.state.user.name;
    },
    canClick() {
      return this.$store.state.user.changePwd;
    },
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
    toPassword() {
      this.$router.push("/password")
    },
    async logout() {
      await this.$store.dispatch("logout").then((res) => {
        this.$store.dispatch("clearStorage");
        // this.$router.push("/login");
        window.location.reload();
        // this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      });
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dropdown-menu {
  .router-link-active {
    .el-dropdown-menu__item {
      line-height: 25px;
    }
  }
  .el-dropdown-menu__item {
    line-height: 25px;
  }
}

.user-info {
  margin-right: 35px;
  margin-left: 10px;
  float: left;
  // font-weight: bold;
  color: rgba(0, 0, 0, 0.75);
  // line-height: 50px;
  font-size: 14px;
}
.aBn{
  cursor: pointer;
  color: #409eff;
}
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 10px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
